import Badge from "@mui/material/Badge";

const CustomBadge = ({ badgeContent, label, sx = {} }) => {
  return (
    <div>
      {badgeContent > 0 ? (
        <Badge
          badgeContent={badgeContent}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#FF3E46",
              color: "#fff",
              fontSize: "8px",
              height: "16px",
              minWidth: "16px",
              padding: "3px",
              top: "0",
              right: "-5px",
              '@media (min-width:1200px) and (max-width:1400px)': {
                top: "7px",
                right: "6px"
              },
              '@media (min-width:1400px) and (max-width:1600px)': {
                top: "-4px",
                right: "0px"
              },
              ...sx,
            },
          }}
        >
          {label}
        </Badge>
      ) : (
        label // Render label directly if badgeContent is 0 or not present
      )}
    </div>
  );
};

export default CustomBadge;
